import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App.vue'
import VueResource from 'vue-resource';
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import vuetify from './plugins/vuetify';
import VueTheMask from 'vue-the-mask';


Vue.use(VueRouter);
Vue.use(VueResource);
Vue.http.options.root = process.env.VUE_APP_URL;
Vue.use(vuetify);
Vue.use(VueTheMask);

Vue.config.productionTip = false

const router = new VueRouter({
  routes: [
      {path: '/:token', component: App, props: true}
  ]
});

new Vue({
    render: h => h(App),
    vuetify,
    router
}).$mount('#app');

(function() {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = '//api.usersnap.com/load/'+
        '1624ef53-7a7b-43c6-83e0-04c227927c66.js';
    var x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
})();

